import { isOverlayLayer, matchLayerIdentifier, PrimitiveRole, PrimitiveType, } from "@buildwithflux/models";
import { mat3 } from "../../../common";
export function createPrimitivesForCircle(node, stackup) {
    const transform = node.bakedRules.transformRelativeToShapesLayer ?? mat3.makeIdentity(); // TODO: fix - this nullish coalescing is needed due to invalid test data in pcb-layouts directory
    const transformInverse = mat3.invert(transform);
    const layerId = stackup.find((layer) => isOverlayLayer(layer) && matchLayerIdentifier(layer, node.bakedRules.layer));
    const strokeWidth = node.bakedRules.strokeWidth ?? 0;
    const isSquare = node.bakedRules.size.x === node.bakedRules.size.y;
    if (isSquare) {
        return [
            {
                type: PrimitiveType.Circle,
                radius: strokeWidth + node.bakedRules.scale.x * (node.bakedRules.size.x / 2),
                transform,
                transformInverse,
                layerId: layerId?.uid ?? null,
                role: PrimitiveRole.silkScreen,
            },
        ];
    }
    else {
        return [
            {
                type: PrimitiveType.Oblong,
                width: strokeWidth + node.bakedRules.scale.x * node.bakedRules.size.x,
                height: strokeWidth + node.bakedRules.scale.y * node.bakedRules.size.y,
                transform,
                transformInverse,
                layerId: layerId?.uid ?? null,
                role: PrimitiveRole.silkScreen,
            },
        ];
    }
}
//# sourceMappingURL=createPrimitivesForCircle.js.map